import { ConfigConstants } from '../config/config-constants';
import { Equipment } from './equipment';
import { initialNotificationIdentifierState, NotificationIdentifier } from './notification-identifier';
import { initialNotificationStatusState, NotificationStatus } from './notification-status';
import { AddressState, initialAddressState } from '../state/address';

export type Notification = Readonly<{
    identifier: NotificationIdentifier;
    backendStatus: NotificationStatus;
    updatedStatus: NotificationStatus;
    languageId: string;
    notificationType: ConfigConstants.NotificationTypes;
    address: AddressState;
    equipmentSet: Equipment[];
    emailSet: string[];
    functionalLocation: string;
}>;

export const initialNotificationState: Notification = {
    identifier: initialNotificationIdentifierState,
    // No Backend connection, we just use the status from evo
    backendStatus: initialNotificationStatusState,
    // This is where we put the state when we get it from evo
    updatedStatus: initialNotificationStatusState,
    languageId: '',
    notificationType: ConfigConstants.NotificationTypes.Unknown,
    address: initialAddressState,
    equipmentSet: [],
    emailSet: [],
    functionalLocation: '',
};
